import lod_ from "lodash";
import { ExpandMore } from "@mui/icons-material";
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Autocomplete,
	Chip,
	FormControl,
	Icon,
	InputLabel,
	MenuItem,
	Select,
	Tab,
	Tabs,
	Tooltip
} from "@mui/material";
import MDBox from "components/Basics/MDBox";
import MDInput from "components/Basics/MDInput";
import MDTypography from "components/Basics/MDTypography";
import { t } from "i18next";
import { useState } from "react";
import MDButton from "components/Basics/MDButton";

/**
 * Right pannel for dynamic list
 * @param {*} param0
 * @returns
 */
const PannelDynamicList = ({ values, handleInputChange, listAPIs, PI }) => {
	const [stringWarnAddWD, setStringWarnAddWD] = useState("");
	const [showWarningWD, setShowWarningWD] = useState(false);

	const updateDynamic = e => {
		handleInputChange(e);
	};

	let onChangeDynamicTag = (child, list, error = true) => {
		if (list.includes(values?.whitelistDynamic?.params?.attribute) && error) {
			setShowWarningWD(true);
			setStringWarnAddWD(t("FORMS.attributeWD"));
			setTimeout(() => {
				setShowWarningWD(false);
			}, 3000);
		} else {
			let e = { target: { name: child, value: list } };
			handleInputChange(e);
		}
	};

	const migrateToV2 = () => {
		// 1. Set version to 2.0
		onChangeDynamicTag("whitelistDynamic.version", "2.0", false);
		// 2. Set displayMode: grid
		onChangeDynamicTag("whitelistDynamic.params.displayMode", "grid", false);
		// 3. Set display -> searchFields
		onChangeDynamicTag(
			"whitelistDynamic.params.display",
			values?.whitelistDynamic?.params?.searchFields || [],
			false
		);
		// 4. Add attribute to seach fields
		const currentSearchFields = values?.whitelistDynamic?.params?.searchFields || [];
		if (
			!currentSearchFields.includes(values?.whitelistDynamic?.params?.attribute) &&
			!lod_.isEmpty(values?.whitelistDynamic?.params?.attribute)
		) {
			currentSearchFields.push(values?.whitelistDynamic?.params?.attribute);
		}
		onChangeDynamicTag("whitelistDynamic.params.searchFields", currentSearchFields, false);
	};

	const getWhitelistVersion = () => {
		switch (values?.whitelistDynamic?.version) {
			case "2.0": {
				return (
					<MDBox>
						<Chip
							label="v2.0"
							color="info"
							variant="contained"
							sx={{ mt: 1, mb: 1, fontWeight: "bold" }}
						/>
					</MDBox>
				);
			}
			default: {
				return (
					<MDBox
						display="flex"
						flexDirection="row"
						alignItems="center"
						justifyContent="space-between"
					>
						<Chip
							label="v1.0"
							color="warning"
							variant="contained"
							sx={{ mt: 1, mb: 1, fontWeight: "bold" }}
						/>
						<MDButton
							variant="contained"
							color="info"
							sx={{ mt: 1, mb: 1 }}
							size="small"
							onClick={migrateToV2}
						>
							Migrer vers la V2
						</MDButton>
					</MDBox>
				);
			}
		}
	};

	return (
		<MDBox display="flex" flex="1">
			<div style={{ borderLeft: "1px solid #ccc", height: "100%", margin: "0 10px" }} />
			<MDBox display="flex" flexDirection="column" width="100%">
				<MDTypography variant="h6">{t("FORMS.addDynamic")}</MDTypography>
				{getWhitelistVersion()}
				<FormControl sx={{ mt: 1 }}>
					<InputLabel id="select-label">{t("FORMS.apiName")}</InputLabel>
					<Select
						labelId="select-label"
						id="select"
						name="whitelistDynamic.apiName"
						value={values?.whitelistDynamic?.apiName || ""}
						onChange={updateDynamic}
					>
						{listAPIs
							?.sort((a, b) => a.name.localeCompare(b.name))
							?.map((api, index) => (
								<MenuItem key={index} value={api.name}>
									{api.name}
								</MenuItem>
							))}
					</Select>
				</FormControl>

				<FormControl sx={{ mt: 1, mb: 1 }}>
					<InputLabel id="select-label">{t("FORMS.actionAPI")}</InputLabel>
					<Select
						labelId="select-label"
						id="select"
						name="whitelistDynamic.action"
						value={values?.whitelistDynamic?.action || ""} /// Par défaut on laisse getRessourceWithQuery
						onChange={updateDynamic}
					>
						{Object.keys(
							listAPIs.find(item => item.name === values?.whitelistDynamic?.apiName)?.config
								?.action || {}
						).map((apiName, index) => (
							<MenuItem key={index} value={apiName}>
								{apiName}
							</MenuItem>
						))}
					</Select>
				</FormControl>

				<Accordion defaultExpanded className="customAccordion">
					<AccordionSummary
						expandIcon={<ExpandMore />}
						aria-controls="panel1a-content"
						id="panel1a-header"
					>
						{t("FORMS.pramsAPI")}
					</AccordionSummary>
					<AccordionDetails>
						<MDInput
							sx={{ mt: 1 }}
							name="whitelistDynamic.params.attribute"
							className="dialogInput"
							label={t("FORMS.attributeAPI")}
							key="0"
							value={values?.whitelistDynamic?.params?.attribute || ""}
							disabled={!PI}
							onChange={updateDynamic}
						/>
						{/* Search fields */}
						<SearchFieldsInput
							showWarningWD={showWarningWD}
							stringWarnAddWD={stringWarnAddWD}
							values={values}
							onChangeDynamicTag={onChangeDynamicTag}
							PI={PI}
						/>
						{/* V2 */}
						{values?.whitelistDynamic?.version === "2.0" && (
							<MDBox>
								{/* Display mode */}
								<MDTypography variant="caption" sx={{ mt: 1 }}>
									Affichage
								</MDTypography>
								<Tabs
									value={values?.whitelistDynamic?.params?.displayMode === "grid" ? 0 : 1}
									onChange={(e, newValue) => {
										const newDisplayMode = newValue === 0 ? "grid" : "text";
										onChangeDynamicTag("whitelistDynamic.params.displayMode", newDisplayMode);
										if (newDisplayMode === "grid") {
											onChangeDynamicTag("whitelistDynamic.params.display", []);
										} else {
											onChangeDynamicTag("whitelistDynamic.params.display", "");
										}
									}}
								>
									<Tab
										label="Grille"
										icon={
											<Icon fontSize="small" sx={{ mt: -0.25 }}>
												view_column
											</Icon>
										}
									/>
									<Tab
										label="Texte"
										icon={
											<Icon fontSize="small" sx={{ mt: -0.25 }}>
												text_format
											</Icon>
										}
									/>
								</Tabs>
								{values?.whitelistDynamic?.params?.displayMode === "grid" && (
									<MDBox mt={1}>
										<DisplayGridFields values={values} onChangeDynamicTag={onChangeDynamicTag} />
									</MDBox>
								)}
								{values?.whitelistDynamic?.params?.displayMode === "text" && (
									<MDBox mt={1}>
										<MDInput
											fullWidth
											label="Texte à afficher"
											placeholder="N° {{ code }} - {{ name }}"
										/>
									</MDBox>
								)}
							</MDBox>
						)}
					</AccordionDetails>
				</Accordion>
			</MDBox>
		</MDBox>
	);
};

const SearchFieldsInput = ({ showWarningWD, stringWarnAddWD, values, onChangeDynamicTag, PI }) => {
	const [inputValue, setInputValue] = useState("");
	return (
		<MDBox>
			<Tooltip
				open={showWarningWD}
				title={stringWarnAddWD}
				placement="right"
				disableFocusListener
				disableHoverListener
				disableTouchListener
			>
				<Autocomplete
					value={
						lod_.isArray(values?.whitelistDynamic?.params?.searchFields)
							? values?.whitelistDynamic?.params?.searchFields
							: []
					}
					onChange={(e, newValue) => {
						onChangeDynamicTag("whitelistDynamic.params.searchFields", newValue);
					}}
					onInputChange={(e, newInputValue) => {
						setInputValue(newInputValue);
					}}
					onBlur={e => {
						if (e.target.value) {
							onChangeDynamicTag("whitelistDynamic.params.searchFields", [
								...(values?.whitelistDynamic?.params?.searchFields ?? []),
								e.target.value
							]);
						}
						setInputValue(""); // Clear the input after blur
					}}
					sx={{ mt: 1 }}
					readOnly={!PI}
					multiple
					id="tags-filled"
					options={[]}
					freeSolo
					inputValue={inputValue}
					renderTags={(tags, getTagProps) => {
						return tags.map((option, index) => {
							return <Chip label={option} {...getTagProps({ index })} key={index} />;
						});
					}}
					renderInput={params => <MDInput {...params} label={t("FORMS.searchFieldsAPI")} />}
				/>
			</Tooltip>
		</MDBox>
	);
};

const DisplayGridFields = ({ values, onChangeDynamicTag }) => {
	const [inputValue, setInputValue] = useState("");
	return (
		<Autocomplete
			value={
				lod_.isArray(values?.whitelistDynamic?.params?.display)
					? values?.whitelistDynamic?.params?.display
					: []
			}
			onChange={(e, newValue) => {
				onChangeDynamicTag("whitelistDynamic.params.display", newValue);
			}}
			onInputChange={(e, newInputValue) => {
				setInputValue(newInputValue);
			}}
			onBlur={e => {
				if (e.target.value) {
					onChangeDynamicTag("whitelistDynamic.params.display", [
						...(values?.whitelistDynamic?.params?.display ?? []),
						e.target.value
					]);
				}
				setInputValue(""); // Clear the input after blur
			}}
			sx={{ mt: 1 }}
			multiple
			id="tags-filled"
			options={[]}
			freeSolo
			inputValue={inputValue}
			renderTags={(tags, getTagProps) => {
				return tags.map((option, index) => {
					return <Chip label={option} {...getTagProps({ index })} key={index} />;
				});
			}}
			renderInput={params => <MDInput {...params} label="Eléments à afficher" />}
		/>
	);
};

export default PannelDynamicList;
